import { render, staticRenderFns } from "./edit-service-time.vue?vue&type=template&id=cff15b4a&"
import script from "./edit-service-time.vue?vue&type=script&lang=js&"
export * from "./edit-service-time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports